import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { fontStyles } from "../style/common_font";
import { RowView2 } from "../style/common_style";

export const PlatformBusinessDetails = () => <>
  <div>상호 : 기역기역 주식회사</div>
  <div>대표자 : 이헌영</div>
  <div>사업자등록번호 : 669-87-03262</div>
  <div>사업장 주소 : 전남광주통합특별시 동구 필문대로 287번길 3</div>
  <div>연락처 : 0507-1336-7115</div>
  <div>E-mail : linkcampus01@gmail.com</div>
</>;

const Footer = () => {
  const Navigate = useNavigate();

  const go_rule = () => Navigate("/rule/1");
  const go_rule2 = () => Navigate("/rule/2");

  return (
    <FooterArea>
      <Rule>
        <div onClick={go_rule}>이용약관</div>
        <div onClick={go_rule2}>개인정보처리방침</div>
      </Rule>
      <Hr />

      <InfoBox>
        <PlatformBusinessDetails />
      </InfoBox>
    </FooterArea>
  );
};

export default Footer;

const FooterArea = styled.div`
  padding: 5rem 1rem 2rem 1rem;
  margin-top: auto;
  flex-shrink: 0;
  color: var(--user-text-muted);
`;
const Rule = styled(RowView2)`
  ${fontStyles.semiBold}
  div {
    margin-right: 1rem;
    cursor: pointer;
  }
`;
const Hr = styled.div`
  width: 100%;
  height: 1px;
  margin: 1rem 0rem;
  background-color: var(--user-border);
`;
const InfoBox = styled.div`
  font-size: 14px;
  line-height: 25px;
  span {
    margin-left: 1.5rem;
  }
  div.click {
    cursor: pointer;
  }
`;
